/* eslint-disable react/prop-types */
export default function Modal({ title, children, onClose }) {
  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-umber/70 p-4" role="dialog" aria-modal="true">
      <section className="card relative flex max-h-[90vh] w-full max-w-2xl flex-col overflow-auto">
        {onClose && (
          <button className="absolute right-4 top-5 border-0 bg-transparent text-2xl leading-none text-subtle hover:text-ink" onClick={onClose} aria-label="Close">×</button>
        )}
        <h2 className="pr-8 font-serif text-2xl">{title}</h2>
        <div className="mt-5 min-w-0">{children}</div>
      </section>
    </div>
  );
}
